<script>
  import './style.scss';
  import template from './template.html';
  import axios from 'axios';
  import { CalendarCheckIcon } from '../icons.js';
  import moment from 'moment';
  
  import {
    AsLink,
    AsStatus,
    AsInfo,
    AsDue,
    AsCell,
    AsComments,
  } from '../Acclaro-Datatable/cells';
  
  import {
    MessageTextIcon
  } from '../icons.js';
  
  export default {
    
    props: {
      orderId: {
        default: 0
      }
    },
    
    beforeMount () {
      this.checkReviewTasks();
    },
    
    computed: {
      
      datatablesRoute () {
        return `/datatables/tasks/${this.orderId}`;
      },
      
      templates () {
        let $vm = this;
        
        return {
          'Task Name': function (h, row, index) {
            const props = { row, column: 'Task Name' };
            const taskName = row['Task Name'];
            
            return (
              <AsLink
                props={props}
                link={'/my-review-tasks/' + row.id}
                link-text={taskName}
                has-tooltip={taskName && taskName.length > 20}
                new-tab={false} />
            );
          },
          
          'Review Status': function (h, row, index) {
            const props = { row, column: 'Review Status' };
            return (
              <AsStatus
                props={props}
                fill-color={$vm.reviewStatusColor(row['Review Status'])} />
            );
          },
          
          Assigned: function (h, row, index) {
            const props = { row, column: 'Assigned' };
            return (
              <AsCell props={props} content={$vm.formatDate(props.row.Assigned)} />
            );
          },
          
          Comments: function (h, row, index) {
            const props = { row, column: 'Comments'};
            let $content = (<span>-</span>);
            
            if (row.has_comments) {
              $content = (
                <div class="center-cell">
                  <MessageTextIcon
                    title="Task Comments"
                    onClick={($event) => $vm.toggleTaskComments($event, row.id)}
                    class="clickable"
                    size={17}
                  />
                </div>
              );
            }

            return $content
          },
          
          Due: function (h, row, index) {
            return (
              <div>
                <span style={$vm.pastDue(row['Due']) && !row.Completed ? 'color:#CC0000' : ''}>
                  {$vm.formatDate(row['Due'])}
                </span>
              </div>
            );
          },
        }
      },
    },
    
    methods: {
      
      toggleTaskComments ($event, taskId) {
        if ($event) {
          $event.stopPropagation();
        }
        
        axios.get(`/my-review-tasks/${taskId}/comments/ajax`, {
          params: {
            hide_controls: true
          }
        }).then(result => {
            let { data: comments } = result;
            this.$modal.show({
              template: `
                <section class="acclaro-modal">
                  <header class="am-header">
                    <h1>Task ${taskId} Comments</h1>
                  </header>
                  <div class="am-content">
                    ${comments}
                  </div>
                  <div class="am-footer">
                    <a v-bind:href="'/my-review-tasks/${taskId}'"><button class="popup-confirm-btn btn-primary">Open Task</button></a>
                    <button class="popup-cancel-btn btn-secondary" @click="$emit('close')">Close</button>
                  </div>
                </section>
              `
            });
        });
      },
      
      checkReviewTasks () {
        axios.get(this.datatablesRoute)
          .then((result) => {
            if ( result.data.data.length ) {
              this.hasReviewTasks = true;
            }
          })
      },
      
      formatDate (date) {
        if (!moment(date).isValid()) return '-';

        return moment(date).format('DD-MMM-YYYY')
      },
      
      pastDue (date) {
        if (!moment(date).isValid()) return false;

        return moment(date).isBefore(moment(), 'day');
      },
      
      toggleFilelessTaskAssigner (state) {
        this.showFilelessTaskAssigner = state;
      },
      
      refreshTable () {
        
        if (this.hasReviewTasks) {
          this.$refs.acclaroSearchView.refreshTable();
        } else {
          this.checkReviewTasks();
        }
      },
      
      onTaskCreated () {
        this.refreshTable();
        this.hasReviewTasks = true
      },
      
      reviewStatusColor (status) {
        const reviewStatusColors = {
          'assigned': '#1F8CEE',
          'open': '#1F8CEE',
          'complete': '#68C71E',
          'canceled': '#000000'
        };

        return reviewStatusColors[status];
      },
    },
    
    template,
    
    data () {
      return {
        
        hasReviewTasks: false,
        
        showFilelessTaskAssigner: false
      }
    },
    
    components: {
      
      CalendarCheckIcon
    }
  };
</script>
